import { useMemo } from 'react'
import useAuth from 'hooks/useAuth'

export default function useDetectVersion() {
  const { profile } = useAuth()

  const isVersionAccessable = useMemo(() => {
    if (profile?.hasAccessToVersion === 0 || profile?.hasAccessToVersion) {
      switch (profile.hasAccessToVersion) {
        case 1:
          return ['torisetsu']
        case 2:
          return ['bcp']
        case 3:
          return ['torisetsu', 'bcp']
        case 4:
          return ['tour']
        case 5:
          return ['torisetsu', 'tour']
        case 6:
          return ['bcp', 'tour']
        case 7:
          return ['torisetsu', 'bcp', 'tour']
        default:
          return []
      }
    }
  }, [profile?.hasAccessToVersion])

  return { isVersionAccessable }
}
